import {
  DeviceIsDeviceType,
  DeviceIsSystemType,
} from 'features/Integrations/utils/deviceComparisionUtils';

export const isBuoyDevice = (device) => {
  if (!device) return false;
  return (
    (DeviceIsDeviceType(device, 'Buoy Conditions') &&
      DeviceIsSystemType(device, 'RescAlert Devices')) ||
    String(device?.device_type || '')
      .toLowerCase()
      .includes('buoy')
  );
};

/**
 * Converts a BuoyDatapoint to a pseudo device object for MapLayer usage.
 * @param {import('src/types/devices.types').BuoyDatapoint} datapoint - The BuoyDatapoint to convert.
 * @returns {import('src/types/devices.types').BuoyDevice} Pseudo device object.
 */
export function buoyDatapointToDevice(datapoint) {
  if (!datapoint) return null;

  // Support both BuoyDatapoint and raw observation object
  // Try to extract id, name, and location from either structure
  const id = datapoint.id || datapoint.buoy_id || datapoint.observation_id || '';
  const name = datapoint.name || datapoint.buoy_name || 'Buoy';
  const alias = datapoint.alias || datapoint.buoy_name || undefined;
  // Prefer nested location, else parse from latitude/longitude
  let lat = datapoint.location?.lat;
  let lng = datapoint.location?.lng;
  if (lat == null && datapoint.latitude) lat = parseFloat(datapoint.latitude);
  if (lng == null && datapoint.longitude) lng = parseFloat(datapoint.longitude);
  // Compose data array: if already array, use as is; else wrap in array
  const dataArr = Array.isArray(datapoint.data) ? datapoint.data : [datapoint];

  return {
    id,
    name,
    alias,
    device_type: 'Buoy Conditions',
    device_type_id: 7,
    system_type: 'RescAlert Devices',
    system_type_id: 2,
    location: { lat, lng },
    coordinates: { lat, lng },
    data: dataArr,
    ext_id: id?.toString?.() || '',
    isPseudoDevice: true,
    uid: 0,
    node_id: 0,
    static_id: '',
    workplace_id: 0,
    groups: [],
    status: 1,
    is_offline: 0,
    kill_switch: 0,
    is_dummy: 0,
    is_copy: 0,
  };
}
